import React from 'react';
export function FinalCTA() {
  return <div className="bg-bg3 py-20 px-5 text-center border-t border-border" data-id="element-54">
      <div className="container-custom" data-id="element-55">
        <h2 className="font-bebas text-[clamp(36px,6vw,72px)] text-white leading-none mb-4" data-id="element-56">
          TU NEGOCIO EMPIEZA
          <br data-id="element-57" />
          <em className="text-pink not-italic" data-id="element-58">ESTA SEMANA.</em>
        </h2>
        <p className="text-[16px] text-muted max-w-[480px] mx-auto mb-7.5" data-id="element-59">
          Por el precio de un café por día durante una semana, tenés el método
          completo para emprender desde casa con gelatinas artísticas.
        </p>
        <a href="[CART_LINK]" className="cta-primary mb-4" data-id="element-60">
          EMPEZAR AHORA — $14.999 ARS →
        </a>
        <p className="text-[13px] text-red font-bold mt-4 tracking-[0.5px]" data-id="element-61">
          ⚠️ ME RESERVO EL DERECHO DE CERRAR ESTA OFERTA SIN PREVIO AVISO
        </p>
      </div>
    </div>;
}